import { render, staticRenderFns } from "./list-user-photo.vue?vue&type=template&id=2ccb2896&scoped=true"
import script from "./list-user-photo.vue?vue&type=script&lang=js"
export * from "./list-user-photo.vue?vue&type=script&lang=js"
import style0 from "./list-user-photo.vue?vue&type=style&index=0&id=2ccb2896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb2896",
  null
  
)

export default component.exports